$(document).ready(function() {



  // Form Group Toggline
  $(".advanced-field-display").each(function() {

    var name = $(this).find('input').first().attr("name");

    toggleAdvancedField(name);

    $('input[name="' + name + '"]').change(function() {;

      toggleAdvancedField($(this).attr('name'));
    });

  });

  function toggleAdvancedField(name) {
    if ($('input[name="' + name + '"]:checked').val() != 1) {
      $('input[name="' + name + '"]').parents(".advanced-field-display").first().children('.advanced-field-display-element').hide();
    } else {
      $('input[name="' + name + '"]').parents(".advanced-field-display").first().children('.advanced-field-display-element').show();
    };
  };

  // Tooltips
  $('[data-toggle="tooltip"]').tooltip();

  // Date Pickers
  $(".datepicker").each(function() {

    // Initialize a datepicker
    var tempDate = $(this).val();
    $(this).datepicker();

    // Only preset a date if one exists
    if (tempDate != "") {

      var dateParts = tempDate.split('/');
      var thisDate = new Date(dateParts[2], dateParts[0] - 1, dateParts[1]);

      $(this).datepicker("setDate", thisDate);

    }

  });

  //Popovers
  $(function() {
    $('[data-toggle="popover"]').popover()
  })

  // Sortable OLD
  if ($(".sortable").length) {
    $(".sortable tbody").sortable({
      cursor: 'pointer',
      placeholder: 'placeholder',
      update: function(event, ui) {
        var data = $(this).parent().children("tbody").sortable('serialize');
        $.get($(this).parent().attr("data-sortable") + "?" + data);
      }

    }).disableSelection();

  }
  resetInputMasks();
  // resets all scores on the page based on their data-attributes for each .score
  function resetInputMasks() {
    // read data-attr which stores round enable_custom_settings
    $('.input-score').each(function() {
      var secondaryScoring = $(this).attr("data-secondary-scoring");

      var wrapper = $(this).parents('.score-input-wrapper').first();

      //formatts the columns based on whether or not secondary score is enabled.
      if (secondaryScoring != 1 && wrapper.hasClass('score-primary-input')) {
        wrapper.removeClass('col-md-6');
        wrapper.addClass('col-md-12');
      } else {
        wrapper.removeClass('col-md-12');
        wrapper.addClass('col-md-6');
      }

      if (secondaryScoring != 1 && wrapper.hasClass('score-secondary-input')) {
        wrapper.hide();
      } else {
        wrapper.show();
      }

      var isTime = $(this).attr("data-time");
      var decimalPlaces = $(this).attr("data-decimal");

      var decimalString = "";
      if (decimalPlaces > 0) {
        decimalString += ".";
        for (var i = 0; i < decimalPlaces; i++) {
          var decimalString = decimalString + '9';
        }
      }

      if (isTime) {
        //$(this).inputmask('remove');
        $(this).inputmask("99:99:99" + decimalString, {
          numericInput: true,
          placeholder: "0"
        });
      } else {
        $(this).inputmask("9{1,8}" + decimalString, {
          numericInput: true,
          placeholder: "0"
        });
      }
    });
  }

  // Copy url button
  $(".copy-text").click(function() {
    var copyText = $(this).parent().parent().children(".copy-text-content");
    copyText.select();
    document.execCommand("Copy");
  })

  // To determine what round settings to be used for Sample Score imort csv
  if ($("#scoresImport").length) {
    var base=$("#dowloadSampleScoreCsv").attr("href");

    setRoundId(base);
    $("#roundNameId").change(function() {
        setRoundId(base);
    });
    function setRoundId(base) {
        var roundId=$("#roundNameId").val();
        $("#dowloadSampleScoreCsv").attr("href", base + "?r=" + roundId);
    };


  }
});
